/* ATP Grove: a hillside that fills with olive trees as it scrolls into view. */
(function () {
  'use strict';
  var w = window, d = document;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(w.Shopify && w.Shopify.designMode);
  var rng = function (seed) { return function () { seed |= 0; seed = (seed + 0x6d2b79f5) | 0; var t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; };
  var fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
  var once = function (el, cb, margin) {
    if (!('IntersectionObserver' in w)) { cb(); return; }
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); cb(); } }, { rootMargin: margin || '0px 0px -12% 0px' });
    io.observe(el);
  };

  /* ---------- 5. The grove fills in ---------- */
  function initGrove() {
    Array.prototype.forEach.call(d.querySelectorAll('[data-atp-grove]'), function (hill) {
      var section = hill.closest('.atp-grove');
      var g = hill.querySelector('.atp-grove__trees');
      if (!g || g.childNodes.length) return;
      var count = parseInt(hill.getAttribute('data-trees'), 10) || 140;
      if (w.innerWidth < 750) count = Math.round(count * 0.6);
      var R = rng(48);
      // three terraces: far rows are smaller and paler, near rows larger
      var rows = [
        { y0: 150, y1: 205, s: 0.55, o: 0.6, share: 0.4 },
        { y0: 222, y1: 280, s: 0.85, o: 0.82, share: 0.34 },
        { y0: 305, y1: 365, s: 1.25, o: 1, share: 0.26 }
      ];
      var trees = [];
      rows.forEach(function (row) {
        var n = Math.round(count * row.share);
        for (var i = 0; i < n; i++) {
          var x = (i + R()) / n * 1260 - 30;
          var y = row.y0 + R() * (row.y1 - row.y0);
          trees.push({ x: x, y: y, s: row.s * (0.85 + R() * 0.3), o: row.o });
        }
      });
      trees.sort(function (a, b) { return a.y - b.y; });
      var NS = 'http://www.w3.org/2000/svg', XL = 'http://www.w3.org/1999/xlink';
      trees.forEach(function (t) {
        var wrap = d.createElementNS(NS, 'g');
        wrap.setAttribute('transform', 'translate(' + t.x.toFixed(1) + ' ' + t.y.toFixed(1) + ') scale(' + t.s.toFixed(2) + ')');
        var u = d.createElementNS(NS, 'use');
        u.setAttribute('href', '#atp-grove-tree'); u.setAttributeNS(XL, 'xlink:href', '#atp-grove-tree');
        u.setAttribute('x', '-30'); u.setAttribute('y', '-58'); u.setAttribute('width', '60'); u.setAttribute('height', '60');
        u.setAttribute('class', 'atp-grove__t');
        u.setAttribute('opacity', t.o);
        u.style.setProperty('--d', ((t.x / 1200) * 1.6 + R() * 0.35).toFixed(2) + 's');
        wrap.appendChild(u); g.appendChild(wrap);
      });
      if (reduce || editor) { section.classList.add('is-growing'); return; }
      once(hill, function () { section.classList.add('is-growing'); });
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', initGrove); else initGrove();
  d.addEventListener('shopify:section:load', function () { try { initGrove(); } catch (e) {} });
})();
